import type { ReactNode } from "react";
import { FlowFooter } from "./FlowFooter";
import { useFlowFooterAction } from "./flowFooterContext";

interface PathwayFlowFooterProps {
  showBack: boolean;
  atStart: boolean;
  onBack: () => void;
  isDarkMode?: boolean;
  dock?: ReactNode;
}

export function PathwayFlowFooter({
  showBack,
  atStart,
  onBack,
  isDarkMode,
  dock,
}: PathwayFlowFooterProps) {
  const action = useFlowFooterAction();
  if (!showBack && !action && !dock) return null;

  const backAction = { onClick: onBack, testId: "btn-back" };
  return (
    <FlowFooter
      isDarkMode={isDarkMode}
      fullBleed
      dock={dock}
      cancel={showBack && atStart ? { ...backAction, label: "Cancel" } : undefined}
      back={showBack && !atStart ? { ...backAction, label: "Back" } : undefined}
      primary={action ?? undefined}
      blockedReason={action?.blockedReason}
    />
  );
}
